import React, { Component } from 'react';
import { defaultTo, isEmpty, path, reduce } from 'ramda';
import { withRouter } from 'react-router-dom';

import styles from './styles.m.scss';

import { addPrices, toCurrency, getDiscountFromLineItems } from '../../../../../util/helpers';
import { apiProcessPayment } from '../../../../../api/registration';
import { handleErrorBase, handleSuccessBase } from '../../../../../util/forms';

import Footer from '../../../../../components/Accordion/Footer';
import DiscountForm from '../../../../../components/DiscountForm';
import FormGroup from '../../../../../components/Forms/FormGroup';
import { apiUpdateRegistration } from '../../../../../api/registration';
import FinalPrice from './Components/FinalPrice';
import StripeCheckout from '../../../../../components/StripeCheckout/index';
import { routes } from '../../../..';

class TrainingSummary extends Component {
  render() {
    const { name, setStep, step, training, registration, updateRegistration, history } = this.props;
    if (isEmpty(registration)) return <noscript />;
    const reviews = defaultTo([], registration.reviews);

    const trainings = defaultTo([], registration.trainings);
    const membership = defaultTo({}, path(['memberships', 0], registration));
    const donation = defaultTo({}, path(['donations', 0], registration));
    donation.price = donation.finalPrice;
    const lineItems = [...trainings, membership, donation];
    const discount = getDiscountFromLineItems(lineItems);
    const totalPrices = reduce(addPrices, { total: 0, afterDiscount: 0 }, lineItems);

    return (
      <div>
        <h2 className={styles.stepHeader}>Please review your information</h2>
        <FormGroup label="Registration Details">
          <p>
            <strong>Training:</strong> {training.name}
          </p>
          {!isEmpty(membership) && (
            <p>
              <strong>Membership:</strong> {membership.name}
            </p>
          )}
        </FormGroup>
        <DiscountForm
          discount={discount}
          checkDiscount={(discountCode) => apiUpdateRegistration(registration.id, { discountCode })}
          update={(registration) => updateRegistration(registration)}
        />
        <FormGroup label="Total Due">
          <table className="table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Price</th>
                <th>Discount</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {trainings.map((training) => (
                <tr key={training.id}>
                  <th>{training.name}</th>
                  <td>{toCurrency(training.price)}</td>
                  <td>
                    {discount.module && discount.percentage
                      ? `-${discount.amount}%`
                      : training.price - training.finalPrice == 300
                      ? '3 Module Discount ($300)'
                      : ''}
                  </td>
                  <td>
                    <FinalPrice lineItem={training} readonly />
                  </td>
                </tr>
              ))}
              {!isEmpty(membership) && (
                <tr>
                  <th>{membership.name}</th>
                  <td>{toCurrency(membership.price)}</td>
                  <td>{discount.membership && discount.percentage && `-${discount.amount}%`}</td>
                  <td>
                    <FinalPrice lineItem={membership} readonly />
                  </td>
                </tr>
              )}
              {donation.id && (
                <tr>
                  <th>Donation</th>
                  <td>{toCurrency(donation.price)}</td>
                  <td />
                  <td>
                    <FinalPrice lineItem={donation} readonly />
                  </td>
                </tr>
              )}
              <tr>
                <th>Total</th>
                <td>{toCurrency(totalPrices.total)}</td>
                <td>{!isEmpty(discount) && !discount.percentage && `-${toCurrency(discount.amount)}`}</td>
                <td>{toCurrency(totalPrices.afterDiscount)}</td>
              </tr>
            </tbody>
          </table>
          <p className="subtext">These items will be charged once your registration has been accepted</p>
        </FormGroup>
        <Footer
          step={step}
          setStep={setStep}
          finishBtn={() => {
            if (reviews.length > 0) {
              return (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    apiProcessPayment(registration.id, { stepName: name })
                      .then(({ data }) => updateRegistration(data))
                      .then(() => handleSuccessBase())
                      .catch(() => handleErrorBase())
                  }
                >
                  Submit
                </button>
              );
            }

            return (
              <StripeCheckout
                name="Sage Financial Solutions"
                description="Registration Payment"
                amount={Number(totalPrices.afterDiscount)}
                pay={(token, overrides = {}) =>
                  apiProcessPayment(registration.id, { stepName: name, token, ...overrides })
                    .then(({ data }) => updateRegistration(data))
                    .then(() =>
                      history.push(routes.certificationsAndTraining.register.trainingPaidBuilder(training.categoryId)),
                    )
                    .then(() => handleSuccessBase())
                    .catch(() => handleErrorBase())
                }
              />
            );
          }}
        />
      </div>
    );
  }
}

export default withRouter(TrainingSummary);
